import { genAIModelOptions, userManagementOptions } from "constants/Constants";
import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Select from "react-select";

const UpdateOrganization = ({
  organizationData,
  setOrganizationData,
  availableFeatures,
  setUpdatedFeatures,
  updatedFeatures,
  userManagements,
}) => {

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setOrganizationData((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };
  return (
    <>
      <Form>
        <Row>
          <Col md={6}>
            <Form.Label>Name </Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder="name"
              required
              value={organizationData?.name}
              onChange={handleOnChange}
            />
          </Col>
          {/* <Col md={6}>
            <Form.Label>Email </Form.Label>
            <Form.Control
              type="email"
              name="email"
              placeholder="Email"
              required
              value={organizationData?.email}
              onChange={handleOnChange}
            />
          </Col> */}
          <Col md={6}>
            {" "}
            <Form.Label>Address </Form.Label>
            <Form.Control
              type="text"
              name="address"
              placeholder="Email address"
              value={organizationData?.address}
              required
              onChange={handleOnChange}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Label>Phone number </Form.Label>
            <Form.Control
              type="text"
              placeholder="Phone number"
              name="phoneNumber"
              required
              value={organizationData?.phoneNumber}
              onChange={handleOnChange}
            />
          </Col>
          {/* <Col md={6}>
            <Form.Group>
              <Form.Label>User Management</Form.Label>
              <Form.Select
                name="userManagement"
                value={organizationData?.userManagement}
                onChange={handleOnChange}
                className="form-control"
              >
                {userManagementOptions.map((option) => {
                  return (
                    <option
                      selected={option === organizationData?.userManagement}
                      value={option}
                    >
                      {option}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Col> */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>User Management</Form.Label>
              <Form.Select
                name="userManagement"
                value={organizationData?.userManagement}
                onChange={handleOnChange}
                className="form-control"
                disabled
              >
                {userManagements.map((option) => {
                  return (
                    <option
                      selected={
                        option?.value === organizationData?.userManagement
                      }
                      value={option?.value}
                    >
                      {option?.label}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Label>Storage </Form.Label>
            <Form.Control
              type="text"
              placeholder="Storage"
              name="storage"
              required
              value={organizationData?.storage}
              onChange={handleOnChange}
            />
          </Col>

          <Col md={6}>
            <Form.Label>Total Users </Form.Label>
            <Form.Control
              type="number"
              placeholder="Storage"
              name="totalUsers"
              required
              value={parseInt(organizationData?.totalUsers)}
              onChange={handleOnChange}
            />
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Main Bucket</Form.Label>
              <Form.Control
                type="text"
                name="mainBucket"
                placeholder="Enter Main Bucket Name"
                value={organizationData.mainBucket}
                required
                disabled
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Videos Bucket</Form.Label>
              <Form.Control
                type="text"
                name="videosBucket"
                placeholder="Enter Videos Bucket Name"
                value={organizationData.videosBucket}
                required
                disabled
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Gen AI Model</Form.Label>
              <Form.Select
                name="genAIModel"
                value={organizationData?.genAIModel}
                onChange={handleOnChange}
                className="form-control"
              >
                {genAIModelOptions.map((option) => {
                  return (
                    <option
                      selected={option === organizationData?.genAIModel}
                      value={option}
                    >
                      {option}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Features</Form.Label>
              <Select
                isMulti
                name="features"
                options={availableFeatures}
                //   value={availableFeatures.filter((opt) =>
                //     formData.features.includes(opt.value)
                //   )}
                //   onChange={(selectedOptions) => {
                //     setFormData((prev) => ({
                //       ...prev,
                //       features: selectedOptions.map((opt) => opt.value),
                //     }));
                //   }}

                value={updatedFeatures}
                onChange={(e) => {
                  setUpdatedFeatures(e);
                }}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default UpdateOrganization;
